const SPECIAL = /[!@#$%^&*()_+\-=[\]{};:,.<>?]/;
export function validatePassword(pw: string): string | null {
  if (pw.length < 8) return '密码至少8位';
  if (!/[A-Z]/.test(pw)) return '密码需包含大写字母';
  if (!/[0-9]/.test(pw)) return '密码需包含数字';
  if (!SPECIAL.test(pw)) return '密码需包含特殊字符';
  return null;
}
